export default __webpack_public_path__ + "static/media/elobow_pain.151bfcdc.png";